import { required } from "vuelidate/lib/validators";
import { Parkinglot } from "@/models/parkinglot.model";

export const ParkinglotConfig = () => {
  return {
    administrator: [],
    level: window.localStorage.getItem("level"),
    isRegist: true,
    isMapView: false,
    memoContent: "",
    memoList: [],
    newExpansionType: [
      { value: 0, text: "N" },
      { value: 1, text: "Y" },
    ],
    operateType: [
      { value: "1", text: "공영" },
      { value: "2", text: "민영" },
    ],
    cateNameList: [],
    areaNameList: [],
    regionNameList: [],
    dialList: [],
    operatingList: [],
    hourList: Array(24)
      .fill(null)
      .map((x, i) => {
        return { value: i, text: i < 10 ? `0${i}시` : `${i}시` };
      }),
    minuteList: Array(6)
      .fill(null)
      .map((x, i) => {
        return { value: i * 10, text: i === 0 ? `0${i}분` : `${i * 10}분` };
      }),
    divisionList: [
      { value: 1, text: "아이파킹존" },
      { value: 2, text: "앱제휴" },
      { value: 3, text: "발렛파킹존" },
    ],
    nyCheckList: [
      { value: "0", text: "N" },
      { value: "1", text: "Y" },
    ],
    useLandList: [
      { value: 1, text: "대지" },
      { value: 2, text: "주차장" },
      { value: 3, text: "잡종지" },
      { value: 4, text: "녹지" },
      { value: 5, text: "전" },
      { value: 6, text: "기타" },
    ],
    systemVendorList: [
      { value: 1, text: "파클" },
      { value: 2, text: "아마노" },
    ],
    systemList: [
      { value: 1, text: "수동" },
      { value: 2, text: "주차권" },
      { value: 3, text: "화상인식" },
      { value: 4, text: "파클" },
    ],
    payPointList: [
      { value: 1, text: "사전정산" },
      { value: 2, text: "출구정산" },
      { value: 3, text: "사전+출구" },
    ],
    reduceInfoList: [
      { value: 1, text: "국가유공자", checked: false },
      { value: 2, text: "5.18", checked: false },
      { value: 4, text: "고엽제", checked: false },
      { value: 8, text: "장애인", checked: false },
      { value: 16, text: "다둥이(2인)", checked: false },
      { value: 32, text: "다둥이(3인)", checked: false },
      { value: 64, text: "저공해차량", checked: false },
      { value: 128, text: "경차", checked: false },
      { value: 256, text: "승용차요일제", checked: false },
      { value: 512, text: "성실납세자", checked: false },
    ],
    payMachineList: [
      { value: 1, text: "유인정상" },
      { value: 2, text: "무인정산" },
      { value: 3, text: "유무인정산" },
    ],
    regularSystemList: [
      { value: 1, text: "주차권" },
      { value: 2, text: "RF카드" },
      { value: 3, text: "화상인식" },
      { value: 4, text: "파클" },
    ],
    discountList: [
      { value: 1, text: "할인도장" },
      { value: 2, text: "할인권" },
      { value: 3, text: "웹할인" },
      { value: 4, text: "파클" },
    ],
    vatList: [
      { value: 1, text: "포함" },
      { value: 2, text: "별도" },
    ],
    productList: [
      { value: 1, text: "주차상품 판매" },
      { value: 2, text: "주차 차고지 판매" },
      { value: 3, text: "주차 정보 공개" },
    ],
    parkType: [
      { value: 1, text: "노외" },
      { value: 2, text: "노상" },
      { value: 3, text: "부설" },
    ],
    shape1: [
      { value: 5, text: "자주식" },
      { value: 6, text: "기계식" },
    ],
    shape2: {
      "5": [
        { value: "7", text: "건축물" },
        { value: "8", text: "철골구조" },
        { value: "9", text: "나대지" },
        { value: "290", text: "복합" },
        { value: "10", text: "기타" },
      ],
      "6": [
        { value: "11", text: "옥내" },
        { value: "12", text: "옥외" },
      ],
    },
    operate1: [
      { value: 1, text: "자가운영" },
      { value: 2, text: "위탁운영" },
    ],
    operate2: [
      { value: 1258, text: "공영" },
      { value: 1259, text: "민영" },
    ],
    programCmpyList: [{ value: 1, text: "코마" }],
    timeRadio: [
      { value: "1", text: "24시간" },
      { value: "2", text: "시간제" },
      { value: "3", text: "휴무" },
      { value: "4", text: "정보없음" },
    ],
    priceType: [
      { value: 0, text: "유료" },
      { value: 1, text: "무료" },
      { value: 2, text: "정보없음" },
    ],
    intervalMinuteList: [
      { value: "1", text: "5" },
      { value: "2", text: "10" },
      { value: "3", text: "15" },
      { value: "6", text: "20" },
      { value: "7", text: "25" },
      { value: "4", text: "30" },
      { value: "8", text: "35" },
      { value: "9", text: "40" },
      { value: "10", text: "45" },
      { value: "11", text: "50" },
      { value: "12", text: "55" },
      { value: "5", text: "60" },
      { value: "15", text: "90" },
      { value: "13", text: "120" },
      { value: "14", text: "180" },
    ],
    intervalChecked: false,
    oneDayMarked: false,
    monthMarked: false,
    dayMonthType: [
      { value: false, text: "상품없음" },
      { value: true, text: "상품있음" },
    ],
    oneDayType: 0,
    monthType: 0,
    appNyList: [
      { value: 1, text: "운영방법", checked: false },
      { value: 2, text: "주차장형태", checked: false },
      { value: 4, text: "SUV 이용가능", checked: false },
      { value: 8, text: "파킹패스", checked: false },
      { value: 16, text: "결제정보", checked: false },
      { value: 32, text: "제휴사할인", checked: false },
      { value: 64, text: "간편결제", checked: false },
      { value: 128, text: "감면적용", checked: false },
      { value: 256, text: "장애인주차", checked: false },
      { value: 512, text: "여성전용주차", checked: false },
      { value: 1024, text: "전기충전소", checked: false },
    ],
    useCarList: [
      { value: 1, text: "승용차(소형)", checked: false },
      { value: 2, text: "승용차(중형)", checked: false },
      { value: 4, text: "SUV", checked: false },
      { value: 8, text: "승합차", checked: false },
      { value: 16, text: "화물(중형)", checked: false },
      { value: 32, text: "화물(대형)", checked: false },
    ],
    payInfo: [
      { value: 1, text: "신용카드전용" },
      { value: 2, text: "현금+카드 결제가능" },
      { value: 3, text: "현금 결제만 가능" },
      { value: 4, text: "없음" },
    ],
    allianceList: [{ value: 1, text: "블루멤버스" }],
    simplePayList: [
      { value: 1, text: "페이코" },
      { value: 2, text: "티머니" },
      { value: 4, text: "삼성페이" },
    ],
    etcInfoList: [
      { value: 1, text: "무인사전정산기", checked: false },
      { value: 2, text: "발렛주차", checked: false },
      { value: 4, text: "주차유도원", checked: false },
    ],
    echargeList: [
      { value: "1", text: "DC차데모" },
      { value: "2", text: "DC차데모+AC3상" },
      { value: "3", text: "DC차데모+AC3상+DC콤보" },
    ],
    updateStateList: [
      { value: 0, text: "미사용" },
      { value: 1, text: "오류정보 신고" },
      { value: 2, text: "주차장 제보" },
    ],
    calendarOptions: {
      firstDayOfWeek: 0,
      dayNames: [
        "일요일",
        "월요일",
        "화요일",
        "수요일",
        "목요일",
        "금요일",
        "토요일",
      ],
      dayNamesShort: ["일", "월", "화", "수", "목", "금", "토"],
      dayNamesMin: ["일", "월", "화", "수", "목", "금", "토"],
      monthNames: [
        "1월",
        "2월",
        "3월",
        "4월",
        "5월",
        "6월",
        "7월",
        "8월",
        "9월",
        "10월",
        "11월",
        "12월",
      ],
      monthNamesShort: [
        "1월",
        "2월",
        "3월",
        "4월",
        "5월",
        "6월",
        "7월",
        "8월",
        "9월",
        "10월",
        "11월",
        "12월",
      ],
      today: "오늘",
      clear: "초기화",
    },
    combineForm: {
      shape1: "",
      shape2: null,
    },
    requiredValue: {
      temporary_ny: 0,
      new_expansion: 0,
    },
  };
};

export const DefaultParkinglot = (): Parkinglot => {
  return {
    additional_interval_minute_cd: null,
    additional_interval_price: null,
    address_1: "",
    address_2: "",
    app_area_length: null,
    app_area_width: null,
    app_inout_heigth: null,
    app_inout_width: null,
    app_vision_available_car: null,
    app_vision_etc_info: null,
    app_vision_info: null,
    app_vision_pay_info: null,
    app_vision_reduce_info: null,
    app_vision_simple_pay: null,
    attachment: {
      "5": [], // 주차상품 대표이미지
      "6": [], // 주차상품(정면)
      "7": [], // 주차상품(출입경로)
      "8": [], // 주차상품(내부)
      "9": [], // 주차상품(정산소, 출구)
      "8000": [], // 영업노트 전용, 신축 공사 이미지 (동기화 불가)
      "8001": [], // 영업노트 전용, 운영시간 이미지 (동기화 불가)
      "8002": [], // 영업노트 전용, 주차요금 이미지 (동기화 불가),
      "8003": [], // 영업노트 전용, 주차대수 이미지 (동기화 불가)
    },
    basic_interval_minute_cd: null,
    basic_interval_price: null,
    biz_hour_cd: "2",
    biz_hour_from_hour: null,
    biz_hour_from_minute: null,
    biz_hour_to_hour: null,
    biz_hour_to_minute: null,
    description: "",
    duplicate_park: 0,
    echarge_cd: null,
    echarge_ny: "0",
    interval_free_ny: 0,
    iparking_attachment: {
      "5": [], // 주차상품 대표이미지
      "6": [], // 주차상품(정면)
      "7": [], // 주차상품(출입경로)
      "8": [], // 주차상품(내부)
      "9": [], // 주차상품(정산소, 출구)
    },
    latitude: "",
    longitude: "",
    oneday_price: null,
    operate_cd: "2",
    operating_cmpy_cd: null,
    parkinglot_type: 0,
    parkname: "",
    park_id: "",
    paclname: "",
    pay_machine_cd: null,
    phone_1: "",
    phone_2: "",
    phone_3: "",
    region_ct: "",
    regular_monthly_price: null,
    sat_biz_hour_cd: "2",
    sat_biz_hour_from_hour: null,
    sat_biz_hour_from_minute: null,
    sat_biz_hour_to_hour: null,
    sat_biz_hour_to_minute: null,
    seq: null,
    shape_ct: "",
    sun_hol_biz_hour_cd: "2",
    sun_hol_biz_hour_from_hour: null,
    sun_hol_biz_hour_from_minute: null,
    sun_hol_biz_hour_to_hour: null,
    sun_hol_biz_hour_to_minute: null,
    total_extent: null,
    total_num: null,
    type_cd: 1,
    update_state: null,
    zipcode: "",
    new_expansion: 0,
    temporary_ny: 0,
    app_vision_info_array: Array(11).fill(""),
    app_vision_available_car_array: Array(6).fill(""),
    app_vision_simple_pay_array: Array(3).fill(""),
    app_vision_reduce_info_array: Array(10).fill(""),
    app_vision_etc_info_array: Array(3).fill(""),
    update_history: [],
    sync: 0,
  };
};

export const requiredValues = {
  new_expansion: "신축 여부",
  parkname: "주차장명",
  address_1: "주소",
  shape_ct: "형태",
  total_num: "총 주차대수",
  operate_cd: "운영방법",
  type_cd: "종류",
  biz_hour_cd: "평일 운영시간",
  sat_biz_hour_cd: "토요일 운영시간",
  sun_hol_biz_hour_cd: "일요일 운영시간",
  interval_free_ny: "주차요금구분",
  app_vision_pay_info: "결제정보",
  echarge_ny: "전기충전소여부",
  oneday_price: "일일요금",
  regular_monthly_price: "월정기요금",
  basic_interval_minute_cd: "기본요금구분",
  basic_interval_price: "기본요금",
  additional_interval_minute_cd: "추가요금구분",
  additional_interval_price: "추가요금",
};

export const formValidations = {
  new_expansion: {
    required,
  },
  parkname: {
    required,
  },
  address_1: {
    required,
  },
  shape_ct: {
    required,
  },
  total_num: {
    required,
  },
  type_cd: {
    required,
  },
  biz_hour_cd: {
    required,
  },
  sat_biz_hour_cd: {
    required,
  },
  sun_hol_biz_hour_cd: {
    required,
  },
  interval_free_ny: {
    required,
  },
  app_vision_pay_info: {
    required,
  },
  echarge_ny: {
    required,
  },
};
